import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getClimateActionListForWorkspaceQueryDocument } from "./climate-action.gql.ts";

export interface UseGetClimateActionListForWorkspaceProps {
  workspaceId?: string;
  enabled?: boolean;
  shouldUpdateCache?: boolean;
}

export const useGetClimateActionListForWorkspace = ({
  workspaceId,
  enabled = true,
}: UseGetClimateActionListForWorkspaceProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.climateActions.list(workspaceId ?? ""),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }

      const client = createOperationClient("GetClimateActionListForWorkspace");
      const data = await client.request(getClimateActionListForWorkspaceQueryDocument, {
        input: { workspaceId },
      });

      return data.climateActionListForWorkspace;
    },
    enabled: enabled && !!workspaceId,
    staleTime: 2 * 60 * 1000, // 2 minutes for list data
  });

  return {
    climateActionList: queryResult.data ?? [],
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
  };
};
